// Constant tables lifted from App.jsx. Every Tailwind class here is a literal so the scanner finds it.

export const PASSCODE = '1207';

// Google Maps browser key (public by design; restricted by HTTP referrer in Google Cloud).
export const GOOGLE_API_KEY = 'AIzaSyAy5MpyGlP4fk-m-jP0B5DDvgfJRjJxLbk';

// Per-profile theme. `classic` wins regardless of profile; otherwise the profile's own palette.
export const THEMES = {
    classic: {
        bg: 'from-amber-50 via-orange-50 to-red-50',
        accent: 'from-orange-400 to-red-400',
        accentHover: 'from-orange-500 to-red-500',
        accentText: 'text-orange-500',
        accentHoverText: 'hover:text-orange-500',
        accentBg: 'bg-orange-100',
        accentBorder: 'border-orange-400',
        tabActive: 'bg-white shadow-lg text-orange-600',
        tabInactive: 'bg-white/60 text-gray-600',
        statColor: 'text-orange-500',
        banner: 'from-orange-400 to-red-400',
        themeClass: '',
    },
    les: {
        bg: 'from-pink-50 via-rose-50 to-fuchsia-50',
        accent: 'from-pink-400 to-rose-500',
        accentHover: 'from-pink-500 to-rose-600',
        accentText: 'text-pink-600',
        accentHoverText: 'hover:text-pink-600',
        accentBg: 'bg-pink-100',
        accentBorder: 'border-pink-400',
        tabActive: 'bg-white shadow-lg text-pink-600',
        tabInactive: 'bg-white/60 text-gray-600',
        statColor: 'text-pink-500',
        banner: 'from-pink-500 to-rose-500',
        themeClass: 'theme-les',
    },
    doug: {
        bg: 'from-amber-50 via-orange-50 to-yellow-50',
        accent: 'from-amber-500 to-orange-400',
        accentHover: 'from-amber-600 to-orange-500',
        accentText: 'text-amber-600',
        accentHoverText: 'hover:text-amber-600',
        accentBg: 'bg-amber-100',
        accentBorder: 'border-amber-500',
        tabActive: 'bg-white shadow-lg text-amber-700',
        tabInactive: 'bg-white/60 text-gray-600',
        statColor: 'text-amber-600',
        banner: 'from-amber-500 to-orange-400',
        themeClass: 'theme-doug',
    },
};

export function themeFor(colorTheme, profile) {
    if (colorTheme === 'classic') return THEMES.classic;
    if (profile === 'les') return THEMES.les;
    return THEMES.doug;
}

// Preset avatar emoji (ProfilePhotoModal)
export const AVATAR_EMOJI = {
    doug: ['👨‍🍳', '🍕', '🍔', '🥩', '🍺', '🎮'],
    les: ['🌸', '💖', '👩‍🍳', '🦩', '🌷', '🧁', '🍓', '🎀'],
};

// Floating background emoji: chooser options (Settings) and the per-profile default when none is chosen
export const FLOATING_EMOJI_OPTIONS = {
    doug: ['☕', '💻', '🖥️', '⌨️', '🤎', '💡'],
    les: ['💖', '✨', '🌸', '💕', '🦋', '🍃'],
};
export const DEFAULT_FLOATING_EMOJI = { doug: '☕', les: '💖' };

// Floating background item positions/timings (FloatingBg)
export const FLOATING_ITEMS = [
    { left: '5%', size: 18, duration: 20, delay: 0 },
    { left: '15%', size: 24, duration: 18, delay: 3 },
    { left: '25%', size: 16, duration: 22, delay: 7 },
    { left: '35%', size: 20, duration: 19, delay: 2 },
    { left: '45%', size: 22, duration: 21, delay: 5 },
    { left: '55%', size: 17, duration: 23, delay: 8 },
    { left: '65%', size: 25, duration: 17, delay: 1 },
    { left: '75%', size: 19, duration: 20, delay: 6 },
    { left: '85%', size: 21, duration: 18, delay: 4 },
    { left: '95%', size: 18, duration: 24, delay: 9 }
];
